import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth, formatApiError } from "@/context/AuthContext";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Loader2 } from "lucide-react";
import { toast } from "sonner";

export default function Login() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      const u = await login(email, password);
      toast.success("Hoş geldiniz!");
      navigate(u.role === "admin" ? "/admin" : "/tasarim");
    } catch (err) {
      setError(formatApiError(err.response?.data?.detail) || err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-atelier flex items-center justify-center px-4">
      <div className="w-full max-w-md">
        <Link to="/" className="flex items-center justify-center gap-2.5 mb-8">
          <img src="/favicon.png" alt="Taban Mobilya logosu" className="h-12 w-12 object-contain" />
          <span className="flex flex-col leading-none">
            <span className="font-serif text-3xl font-bold uppercase tracking-wide text-stone-900">
              Taban <span className="text-primary">Mobilya</span>
            </span>
            <span className="text-[11px] font-mono uppercase tracking-[0.22em] text-stone-500 mt-1">
              3D Mobilya Atölyesi
            </span>
          </span>
        </Link>

        <div className="card-atelier rounded-2xl p-8">
          <h1 className="font-serif text-3xl font-bold text-stone-900 mb-1">Giriş Yap</h1>
          <p className="text-sm text-stone-500 mb-6">Hesabınıza erişmek için giriş yapın.</p>

          <form onSubmit={submit} className="space-y-4">
            <div>
              <Label>E-posta</Label>
              <Input
                data-testid="login-email-input"
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="ornek@eposta.com"
                required
              />
            </div>
            <div>
              <Label>Şifre</Label>
              <Input
                data-testid="login-password-input"
                type="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                placeholder="••••••••"
                required
              />
            </div>
            {error && (
              <p data-testid="login-error" className="text-sm text-red-600 bg-red-50 rounded-lg p-2.5">
                {error}
              </p>
            )}
            <Button data-testid="login-submit-button" type="submit" className="w-full rounded-full" disabled={loading}>
              {loading && <Loader2 className="w-4 h-4 animate-spin" />} Giriş Yap
            </Button>
          </form>

          <p className="text-sm text-stone-500 text-center mt-6">
            Hesabınız yok mu?{" "}
            <Link to="/register" className="text-primary font-semibold hover:underline">
              Üye olun
            </Link>
          </p>
        </div>
      </div>
    </div>
  );
}
